import { useI18n, LANG_LABELS, type Lang } from "@/lib/i18n";
import { Globe } from "lucide-react";

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { lang, setLang } = useI18n();
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2 py-1 text-xs">
      <Globe className="h-3 w-3 text-muted-foreground" />
      {(["en", "hi", "gu"] as Lang[]).map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`rounded-full px-2 py-0.5 font-semibold transition ${lang === l ? "text-primary-foreground" : "text-muted-foreground"}`}
          style={lang === l ? { background: "var(--gradient-saffron)" } : undefined}
        >
          {compact ? l.toUpperCase() : LANG_LABELS[l]}
        </button>
      ))}
    </div>
  );
}
